interface CandidateStats { type?: string; candidateType?: string; url?: string; relayProtocol?: string }

function turnEndpoint(url: string): { key: string; protocol: string } | null {
  const match = /^(turns?):([^?]+)(?:\?(.*))?$/i.exec(url);
  if (!match) return null;
  const transport = new URLSearchParams(match[3] || "").get("transport") || (match[1].toLowerCase() === "turns" ? "tcp" : "udp");
  const protocol = match[1].toLowerCase() === "turns" ? "tls" : transport.toLowerCase();
  if (!["udp", "tcp", "tls"].includes(protocol)) return null;
  return { key: `${match[1].toLowerCase()}:${match[2].toLowerCase()}?transport=${transport.toLowerCase()}`, protocol };
}

/** Only skip the timeout once SDP contains relay candidates for every configured TURN path. */
export function allTurnPathsGathered(servers: RTCIceServer[], stats: CandidateStats[], sdp: string): boolean {
  const required = new Map<string, string>();
  for (const server of servers) {
    for (const url of typeof server.urls === "string" ? [server.urls] : server.urls) {
      const endpoint = turnEndpoint(url);
      if (endpoint) required.set(endpoint.key, endpoint.protocol);
    }
  }
  if (!required.size) return false;
  const relayLines = new Set(sdp.split(/\r?\n/).filter(line => /^a=candidate:.*\styp relay(?:\s|$)/.test(line)));
  if (relayLines.size < required.size) return false;
  for (const candidate of stats) {
    if (candidate.type !== "local-candidate" || candidate.candidateType !== "relay" || !candidate.url) continue;
    const endpoint = turnEndpoint(candidate.url);
    if (endpoint && required.get(endpoint.key) === candidate.relayProtocol?.toLowerCase()) required.delete(endpoint.key);
  }
  return required.size === 0;
}
